export const PARTNER_STATUSES = [
  "NOT_APPLICABLE",
  "NORMAL",
  "POSITIVE",
  "TRIGGERED"
];
